module.exports = __webpack_public_path__ + "resources/icon_44_agree_active.5e28ca96cd7ab5c2.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_agree_active.png
// module id = 433
// module chunks = 0 1 2 3 4